import type { ReactNode } from 'react'

// Control is the frame a typed answer sits in. It carries no visible label on
// purpose: the question is the heading of the screen, and repeating it above
// the box would be saying the same thing twice. The heading is what the input
// is labelled by instead, through aria-label on the input itself.
export function Control({ children }: { children: ReactNode }) {
  return <div className="ask__control">{children}</div>
}
